<template>
  <div class="page page__list">
    <scroll-list @refresh="onSearch" @loadpage="onSearch">
      <div
        class="weui-cell"
        v-for="item in items"
        :key="item.id"
        @click="gotoView(item)"
        :class="{'weui-cell_access':item.type!=0}"
      >
        <div class="weui-cell__bd">
          <p>{{item.name}}</p>
        </div>
        <div class="weui-cell__ft"></div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
    <add-button to="/sys/role_edit" />
  </div>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";

export default {
  components: {
    ScrollList,
    AddButton,
  },
  data() {
    return {
      items: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.onSearch();
    });
  },
  methods: {
    onSearch(callback) {
      var me = this;
      me.$loading({
        url: "/api/account/role/list",
      }).then(function (res) {
        callback && callback.call(me);
        if (res.success) {
          me.items = res.data;
        }
      });
    },
    gotoView(item) {
      if (item.type) {
        this.$router.push("/sys/role/" + item.id);
      }
    },
  },
};
</script>